/**
 *	ModalCtrl.ctrl.js
 */

class ModalCtrl {
    constructor($scope, $element) {
    	this.$element = $element;

		this.initModal();    	
    }

    initModal() {
    	this.$element.modal({
            show: false
        });
    }

    showModal() {
    	this.$element.modal('show');
    }
}

ModalCtrl.$inject = ['$scope', '$element'];

export default ModalCtrl;